import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Something went wrong" };
  }

  componentDidCatch(error, info) {
    // Keep console signal for developers without exposing internals to users.
    console.error("Recho Music UI error", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
        <div className="border-2 border-[#1F2924] bg-[#EAE4D3] p-6 sm:p-8 shadow-tactile">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D35230] mb-3">Receiver recovered</div>
          <h1 className="font-serif-display text-3xl sm:text-5xl leading-tight mb-3">The page lost signal.</h1>
          <p className="text-[#1F2924]/75 leading-relaxed mb-6">
            Your player and account are safe. Refresh the app or go back home to continue listening.
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => window.location.reload()}
              className="px-5 py-3 bg-[#1F2924] text-[#F4F1EA] border-2 border-[#1F2924] font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#D35230] hover:border-[#D35230]"
            >Refresh</button>
            <a
              href="/"
              className="px-5 py-3 bg-[#F4F1EA] text-[#1F2924] border-2 border-[#1F2924] font-mono text-xs uppercase tracking-[0.2em] hover:bg-[#1F2924] hover:text-[#F4F1EA]"
            >Home</a>
          </div>
        </div>
      </div>
    );
  }
}
